import { Level } from "@serophin/nottldr-shared";

/** The colours a level is shown in: lime for beginner, amber for intermediate, orange for advanced. */
type LevelStyle = { text: string; border: string; bg: string };

const STYLES: Record<Level, LevelStyle> = {
  [Level.Beginner]: { text: "text-lime-600", border: "border-lime-600", bg: "bg-lime-600" },
  [Level.Intermediate]: { text: "text-amber-400", border: "border-amber-400", bg: "bg-amber-400" },
  [Level.Advanced]: { text: "text-orange-500", border: "border-orange-500", bg: "bg-orange-500" },
};

export const levelStyle = (level: Level): LevelStyle => STYLES[level];

/** The background of an author's initial when there is no picture: the light neutral. */
export const INITIAL_BG = "bg-neutral-200";
